(() => {
  const imageSelector = [
    'img[alt*="size chart" i]',
    'img[alt*="measurement guide" i]',
    'img[src*="size-chart" i]',
    'img[src*="measurement-guide" i]',
    'img[src*="bodysize" i]',
    '#collapse-tab1 img'
  ].join(',');
  let overlay;

  const isProductDescriptionImage = (image) => {
    if (!image.matches(imageSelector)) return false;
    return Boolean(image.closest('.product-description, .product-single__description, .rte, [data-handle]'));
  };

  const close = () => {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    document.body.style.removeProperty('overflow');
  };

  const open = (image) => {
    close();
    const source = image.currentSrc || image.dataset.src || image.src;
    if (!source) return;
    overlay = document.createElement('div');
    overlay.className = 'rs-size-chart-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', image.alt || 'Size chart');
    overlay.innerHTML = '<button type="button" class="rs-size-chart-lightbox__close" aria-label="Close size chart">×</button><img class="rs-size-chart-lightbox__image" alt="">';
    const preview = overlay.querySelector('img');
    preview.src = source;
    preview.alt = image.alt || 'Size chart';
    Object.assign(overlay.style, { position: 'fixed', inset: '0', zIndex: '2147483000', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: 'rgba(0,0,0,.82)', cursor: 'zoom-out' });
    Object.assign(preview.style, { maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain', background: '#fff', cursor: 'default' });
    const button = overlay.querySelector('button');
    Object.assign(button.style, { position: 'absolute', top: '14px', right: '18px', width: '42px', height: '42px', border: '0', borderRadius: '50%', background: '#fff', color: '#222', fontSize: '32px', lineHeight: '38px', cursor: 'pointer' });
    overlay.addEventListener('click', (event) => { if (event.target === overlay || event.target === button) close(); });
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    button.focus();
  };

  document.addEventListener('click', (event) => {
    const image = event.target.closest('img');
    if (!image || !isProductDescriptionImage(image)) return;
    event.preventDefault();
    open(image);
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  const markCharts = () => document.querySelectorAll(imageSelector).forEach((image) => {
    if (isProductDescriptionImage(image)) {
      image.style.cursor = 'zoom-in';
      image.setAttribute('tabindex', '0');
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const image = document.activeElement;
    if (image?.tagName === 'IMG' && isProductDescriptionImage(image)) { event.preventDefault(); open(image); }
  });
  markCharts();
  new MutationObserver(markCharts).observe(document.documentElement, { childList: true, subtree: true });
})();